module.exports = __webpack_public_path__ + "img/part-4-title.6160ffd8.png";